import styled from '@emotion/styled';
import PropTypes from 'prop-types';
import StarFilled from '@icon/StarFilled';
import { pluralize } from '@utils/textHelper';
import H7 from '../H7/H7';
import P2 from '../P2/P2';
import { Spacings } from '../../../styleConstants';

const colorOrange = 'var(--color-i-orange-1)';
const colorFontLightGrey = 'var(--color-text-secondary)';

const Flex = styled.div`
  display: flex;
  align-items: center;
`;

const Rating = styled(H7)`
  margin-right: ${Spacings.SPACING_3B};
  margin-left: ${Spacings.SPACING_1B};
`;

const Reviews = styled(P2)`
  margin-left: 3px;
  margin-right: 3px;
`;

const StarRating = ({ rating, ratingsCount, reviewsCount, className }) => {
  return (
    <Flex>
      <StarFilled color={colorOrange} size={Spacings.SPACING_3B} />
      <Rating color={colorOrange} className={className}>
        {rating}
      </Rating>
      {ratingsCount ? (
        <P2 color={colorFontLightGrey}>{pluralize(ratingsCount, 'rating')}</P2>
      ) : null}
      {reviewsCount && ratingsCount ? (
        <Reviews color={colorFontLightGrey}> • </Reviews>
      ) : null}
      {reviewsCount ? (
        <P2 color={colorFontLightGrey}>{pluralize(reviewsCount, 'review')}</P2>
      ) : null}
    </Flex>
  );
};

export default StarRating;

StarRating.propTypes = {
  rating: PropTypes.number.isRequired,
  ratingsCount: PropTypes.number.isRequired,
  className: PropTypes.string,
  reviewsCount: PropTypes.number
};

StarRating.defaultProps = {
  className: '',
  reviewsCount: 0
};
